module.exports = __webpack_public_path__ + "static/media/MSTeamsIcon.1cd92916.svg";